import { useCallback } from 'react';
import cx from 'classnames';
import { StopCell } from 'modules/fleet/list';
import { PalletsCell, WeightCell, HeightCell } from 'utils/format';
import { getFakeItineraryForShipperTooltipBasedOnStop, cellWidth } from 'utils/itineraries';
import { ShippersTooltip } from 'modules/fleet/common';

import { ReactComponent as PickupIcon } from 'assets/icons/pickup.svg';
import { ReactComponent as DropoffIcon } from 'assets/icons/dropoff.svg';

import { Button, OrcProvider } from '@ontruck/orc';
import { themeBaseOverwrite, themeComponentBaseOverwrite } from 'utils/style';

const stopTypeIcons = {
  PICKUP: <PickupIcon style={{ width: 16, height: 16 }} />,
  DROPOFF: <DropoffIcon style={{ width: 16, height: 16 }} />,
};

const RoutingMapInfoWindowStop = ({ stop, onClick }) => {
  const handleClick = useCallback(() => {
    onClick(stop);
  }, [onClick, stop]);

  return (
    <div className="RoutingInfoWindowStop">
      <div className={cx('stop defaultCursor')}>
        <div
          className={cx('cell cell__nowrap cell__nopadding cell__center')}
          {...cellWidth('36px')}
          data-testid="RoutingStop_stopType"
        >
          {stopTypeIcons[stop?.stop_type]}
        </div>
        <ShippersTooltip
          itinerary={getFakeItineraryForShipperTooltipBasedOnStop(stop)}
          placement="left"
          trigger="mouseenter"
        >
          <StopCell
            label={stop?.label}
            timeFrom={stop?.time_from}
            timeTo={stop?.time_to}
            {...cellWidth('136px')}
          />
        </ShippersTooltip>
        <div className="cell cell__bold cell__right cell__dark" {...cellWidth('80px')}>
          <PalletsCell
            realPallets={stop?.real_pallets}
            equivalentPallets={stop?.equivalent_pallets}
            typePallets={stop?.type_pallets}
          />
        </div>
        <div className="cell cell__right cell__dark" {...cellWidth('72px')}>
          <WeightCell weight={stop?.total_weight} />
        </div>
        <div className="cell cell__right cell__dark" {...cellWidth('50px')}>
          <HeightCell height={stop?.item_height} />
        </div>
      </div>
      <div className="action-container">
        <Button
          ghost
          skin="primary"
          icon="plus"
          iconPosition="left"
          size="XS"
          onClick={handleClick}
          data-testid="RoutingInfoWindowAddButton"
        />
      </div>
    </div>
  );
};

const RoutingMapInfoWindow = ({ stops = [], onAddClick }) => {
  const handleAddClick = useCallback(
    (stop) => {
      onAddClick && onAddClick(stop.itinerary_id);
    },
    [onAddClick]
  );

  if (!stops?.length) {
    return <div />;
  }

  return (
    <OrcProvider themeBase={themeBaseOverwrite} themeComponentBase={themeComponentBaseOverwrite}>
      <div className="RoutingInfoWindow" data-testid="RoutingMapInfoWindow">
        {stops.map((stop) => (
          <RoutingMapInfoWindowStop key={stop.id} stop={stop} onClick={handleAddClick} />
        ))}
      </div>
    </OrcProvider>
  );
};

export default RoutingMapInfoWindow;
